(ns rlws.iot-cloud.frontend.builder
  (:require [applied-science.js-interop :as jsi]
            [cljs.pprint :as pprint]
            [fork.re-frame :as fork]
            [potpuri.core :as potpuri]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [rlws.iot-cloud.frontend.events :as events]
            [rlws.iot-cloud.frontend.openapi :as openapi]
            [rlws.iot-cloud.frontend.site :as site]
            [rlws.iot-cloud.frontend.subscriptions :as sub]
            [rlws.iot-cloud.frontend.components :as components]
            [rlws.iot-cloud.frontend.uikit.editable-table :refer [editable-table]]
            [vlad.core :as vlad]))

(defn resize-cells
  [cells target-size]
  (if (< (count cells) target-size)
    (let [existing-ids (set (map :id cells))
          available-ids (->> (range target-size)
                             (map inc)
                             (remove existing-ids))]
      (vec (concat cells
                   (for [i available-ids]
                     {:cell-number i
                      :name (str "Cell #" i)
                      :serial ""}))))
    (subvec cells 0 target-size)))

(defn cell-config-modal
  [{:keys [initial-values handle-submit]}]
  [fork/form {:on-submit (fn [data]
                           (handle-submit data)
                           (rf/dispatch [:modal {:show? false :child nil}]))
              :initial-values initial-values
              :prevent-default? true
              :keywordize-keys true}
   (fn [{:keys [state values handle-submit handle-change handle-blur]}]
     (let [{:keys [serial model capacity zero-value factory-sensitivity
                   normalization-value images]} values]
       [:form {:on-submit handle-submit}
        [:div.add-asset.add-asset__modal
         [:div
          [:div.form__group
           [:label.form-label.form__label {:for :serial} "Serial No."]
           [:input.form-control
            {:name :serial
             :type :text
             :placeholder "0123-ABC"
             :value serial
             :on-change handle-change
             :on-blur handle-blur}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :model}
            "Model"]
           [:input.form-control
            {:name :model
             :type :text
             :placeholder "A01203C"
             :value model
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :capacity}
            "Capacity (lbs)"]
           [:input.form-control
            {:name :capacity
             :type :number
             :placeholder "20000"
             :value capacity
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :zero-value}
            "Zero Value"]
           [:input.form-control
            {:name :zero-value
             :type :number
             :placeholder "0"
             :value zero-value
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :factory-sensitivity}
            "Factory Sensivity"]
           [:input.form-control
            {:name :factory-sensitivity
             :type :number
             :placeholder "3"
             :value factory-sensitivity
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :normalization-value}
            "Normalization Value"]
           [:input.form-control
            {:name :normalization-value
             :type :number
             :placeholder "0"
             :value normalization-value
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :image}
            "Image"]
           [components/image-upload
            {:state (r/wrap (get-in @state [:values :image :data])
                            swap! state assoc-in [:values :image :data])}]]]
         [:button.btn {:type "submit"}
          "Update"]]]))])

(defn cell-set-all-config-modal
  [{:keys [handle-submit]}]
  [fork/form {:on-submit (fn [data]
                           (handle-submit data)
                           (rf/dispatch [:modal {:show? false :child nil}]))
              :prevent-default? true
              :keywordize-keys true}
   (fn [{:keys [state values handle-submit handle-change handle-blur]}]
     (let [{:keys [model capacity zero-value factory-sensitivity
                   normalization-value images]} values]
       [:form {:on-submit handle-submit}
        [:div.add-asset.add-asset__modal
         [:div
          [:div.form__group
           [:label.form-label.form__label
            {:for :model}
            "Model"]
           [:input.form-control
            {:name :model
             :type :text
             :placeholder "A01203C"
             :value model
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :capacity}
            "Capacity (lbs)"]
           [:input.form-control
            {:name :capacity
             :type :number
             :placeholder "20000"
             :value capacity
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :zero-value}
            "Zero Value"]
           [:input.form-control
            {:name :zero-value
             :type :number
             :placeholder "0"
             :value zero-value
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :factory-sensitivity}
            "Factory Sensivity"]
           [:input.form-control
            {:name :factory-sensitivity
             :type :number
             :placeholder "3"
             :value factory-sensitivity
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :normalization-value}
            "Normalization Value"]
           [:input.form-control
            {:name :normalization-value
             :type :number
             :placeholder "0"
             :value normalization-value
             :on-blur handle-blur
             :on-change handle-change}]]
          [:div.form__group
           [:label.form-label.form__label
            {:for :image}
            "Image"]
           [components/image-upload
            {:state (r/wrap (get-in @state [:values :image :data])
                            swap! state assoc-in [:values :image :data])}]]]
         [:button.btn {:type "submit"}
          "Update"]]]))])

(defn collapse-cell-config
  "Fold cells into a cell-config element to be used by asset form"
  [asset]
  (let [cells (filter #(= "cell" (:component-type %)) (:components asset))
        cell-config (and (seq cells)
                         {:component-type "cell-config"
                          :cells cells})]
    (cond-> asset
      cell-config
      (update :components (fn [components]
                            (conj (filterv #(not= "cell" (:component-type %)) components)
                                  cell-config))))))

(defn expand-cell-config
  "Unwrap cells from cell-config and return them as individual asset components"
  [asset]
  (let [cell-config (potpuri/find-first
                     (:components asset)
                     {:component-type "cell-config"})
        cells (map #(assoc % :component-type "cell")
                   (:cells cell-config))]
    (update asset :components (fn [components]
                                (vec
                                 (concat
                                  (filter #(not= "cell-config" (:component-type %))
                                          components)
                                  cells))))))

(defn iqube2-component
  [{:keys [handle-change handle-blur] {:keys [ip name port timeout scale]} :values}]
  [:<>
   [:div.form__group
    [:label.form-label.form__label {:for :name} "Name"]
    [:input.form-control.long-input
     {:name :name
      :type :text
      :placeholder "iQube2"
      :value name
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :ip} "IP Address"]
    [:input.form-control.long-input
     {:name :ip
      :type :text
      :placeholder "192.168.1.1"
      :value ip
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :port} "Port Number"]
    [:input.form-control.long-input
     {:name :port
      :type :number
      :placeholder "10001"
      :value port
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :timeout} "Timeout (ms)"]
    [:input.form-control.long-input
     {:name :timeout
      :type :number
      :placeholder "5000"
      :value timeout
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :scale} "Scale Number"]
    [:input.form-control.long-input
     {:name :scale
      :type :text
      :placeholder "1"
      :value scale
      :on-change handle-change
      :on-blur handle-blur}]]])

(defn camera-component
  [{:keys [handle-change handle-blur] {:keys [name ip port timeout]} :values}]
  [:<>
   [:div.form__group
    [:label.form-label.form__label {:for :name} "Name"]
    [:input.form-control.long-input
     {:name :name
      :type :text
      :placeholder "Camera #1"
      :value name
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :ip} "IP Address"]
    [:input.form-control.long-input
     {:name :ip
      :type :text
      :placeholder "192.168.1.1"
      :value ip
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :port} "Port Number"]
    [:input.form-control.long-input
     {:name :port
      :type :number
      :placeholder "10001"
      :value port
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :timeout} "Timeout (ms)"]
    [:input.form-control.long-input
     {:name :timeout
      :type :number
      :placeholder "5000"
      :value timeout
      :on-change handle-change
      :on-blur handle-blur}]]])

(defn generic-component
  [{:keys [handle-change handle-blur]
    {:keys [name model make serial firmware ip mac]} :values}]
  [:<>
   [:div.form__group
    [:label.form-label.form__label {:for :name} "Name"]
    [:input.form-control.long-input
     {:name :name
      :type :text
      :placeholder "Component Name"
      :value name
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :model} "Model"]
    [:input.form-control.long-input
     {:name :model
      :type :text
      :placeholder "Component Model"
      :value model
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :make} "Make"]
    [:input.form-control.long-input
     {:name :make
      :type :text
      :placeholder "Component Make"
      :value make
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :serial} "Serial"]
    [:input.form-control.long-input
     {:name :serial
      :type :text
      :placeholder "Component Serial"
      :value serial
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :firmware} "Firmware"]
    [:input.form-control.long-input
     {:name :firmware
      :type :number
      :placeholder "Component Firmware"
      :value firmware
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :ip} "IP Address"]
    [:input.form-control.long-input
     {:name :ip
      :type :text
      :placeholder "Component IP Address"
      :value ip
      :on-change handle-change
      :on-blur handle-blur}]]
   [:div.form__group
    [:label.form-label.form__label {:for :mac} "MAC"]
    [:input.form-control.long-input
     {:name :mac
      :type :text
      :placeholder "Component MAC Address"
      :value mac
      :on-change handle-change
      :on-blur handle-blur}]]])

(defn cell-config-component
  [{:keys [state handle-change handle-blur index]
    {:keys [model capacity zero-value factory-sensitivity
            normalization-value images] :as values} :values
    :as props}]
  [:<>
   [editable-table
    {:columns [{:key :cell-number
                :label "Cell #"
                :type :integer}
               {:key :serial
                :label "Serial Number"
                :type :string}]
     :actions [{:label "Add Details"
                :action-fn
                (fn [{:keys [update-row]
                      {:keys [id cell-number] :as value} :row-value}]
                  (rf/dispatch
                   [:modal {:show? true
                            :title (str "Modify Cell #" cell-number)
                            :child [cell-config-modal
                                    {:initial-values value
                                     :handle-submit
                                     (fn [data]
                                       (update-row id merge (:values data)))}]}]))}]
     :rows (get-in @state [:values :components index :cells])
     :handle-change (fn [rows]
                      (swap! state assoc-in [:values :components index :cells] rows))
     :sort-fn (fn [{:keys [cell-number]}]
                (or cell-number 99999))
     :new-row (fn [rows]
                (let [max-cell-number (apply max (map :cell-number rows))]
                  {:cell-number (inc (or max-cell-number 0))}))
     :item-label "Cell"
     :additional-controls
     [[:button.btn
       {:type "button"
        :on-click (fn [event]
                    (rf/dispatch
                     [:modal
                      {:show? true
                       :title "Modify All Cells"
                       :child [cell-set-all-config-modal
                               {:handle-submit
                                (fn [data]
                                  (swap! state update-in [:values :components index]
                                         (fn merge-cells-with-new-values
                                           [cell-config]
                                           (assoc cell-config :cells
                                                  (mapv #(merge % (:values data))
                                                        (:cells cell-config))))))}]}]))}
       "Modify All Cells"]]}]])

(def component-order
  {"cell-config" 0
   "iqube2" 1
   "camera" 2
   "indicator" 3
   "remote-display" 4})

(defn asset-builder-components
  [{:keys [state]}]
  (let [asset-components
        (into (hash-map)
              (doall
               (for [[index {:keys [component-type] :as values}]
                     (->> (get-in @state [:values :components])
                          (map-indexed vector)
                          (sort-by (comp component-order
                                         :component-type
                                         second))
                          vec)

                     :when component-type
                     :let [handle-change (fn [event]
                                           (let [{:keys [name value type files]}
                                                 (jsi/lookup (. event -target))]
                                             (case type
                                               "file" (swap! state
                                                             update-in [:values :components index]
                                                             assoc (keyword name) files)

                                               (swap! state
                                                      update-in [:values :components index]
                                                      assoc (keyword name) value))))

                           handle-blur handle-change
                           current-component (case component-type
                                               "iqube2" iqube2-component
                                               "camera" camera-component
                                               "cell-config" cell-config-component
                                               "indicator" generic-component
                                               "remote-display" generic-component
                                               [:div])]]

                 ;; FIXME The first value in this vector is used to determine
                 ;; where in the asset builder a particular component-type
                 ;; should go. There's likely to be a much simpler way of
                 ;; achieving this.
                 [component-type
                  [:div {:key (str "component-" index)
                         :class (str "asset-component " component-type)}
                   [:div.asset-component__header.form__group
                    (let [component-header {"iqube2" "Scale - iQube2"
                                            "camera" "IP Camera"
                                            "cell-config" "Cell Configuration"
                                            "indicator" "Indicator"
                                            "remote-display" "Remote Display"}]
                      [:span (component-header component-type)])
                    [:div.asset-component__remove
                     [:i.fa.fa-trash
                      {:on-click
                       (fn []
                         (components/confirmation-dialog
                          {:action-fn
                           (fn []
                             (swap! state
                                    update-in [:values :components]
                                    (fn [components]
                                      (filterv some? (assoc components index nil)))))
                           :text "Are you sure you want to remove this component?"
                           :title "Confirm Remove"}))}]]]

                   [:div.component-body
                    [current-component {:handle-change handle-change
                                        :handle-blur handle-blur
                                        :values values
                                        :state state
                                        :index index}]]]])))]

    (into [:div.asset-components
           (when-let [cell-config (get asset-components "cell-config")]
             [:div.asset-components__row
              cell-config])
           (for [[index component-row] (->> (vals (dissoc asset-components "cell-config"))
                                            (sort-by (comp component-order
                                                           :component-type))
                                            (partition-all 2)
                                            (map-indexed vector))]
             (into [:div.asset-components__row {:key (str "row-" index)}]
                   component-row))])))

;; NOTE Validation is performed on the component view of the data, not the
;; submitted data. In particular the "collapsed" cell configuration
(def asset-validation
  (vlad/chain
   (vlad/attr [:name] (vlad/present {:message "Asset name is required"}))
   (vlad/attr [:customer] (vlad/present))
   (vlad/attr [:location] (vlad/present {:message "Address is required"}))
   (vlad/attr [:gateway] (vlad/chain
                          (vlad/present)
                          (vlad/matches #"[0-9]+-[0-9]+")))
   (vlad/attr [:components]
              (vlad/chain
               (vlad/predicate
                (fn [components]
                  (some (fn [{:keys [component-type name] :as x}]
                          (and (#{"iqube2" "camera"} component-type)
                               (empty? name)))
                        components))
                {:message "Asset components must have a name"})
               (vlad/predicate
                (fn [components]
                  (let [cell-config (potpuri/find-first
                                     components
                                     {:component-type "cell-config"})
                        cells (:cells cell-config)
                        cell-numbers (map :cell-number cells)]
                    (when cells
                      (or (some (complement pos-int?) cell-numbers)
                          (apply (complement distinct?) cell-numbers)))))
                {:message "All cells must have a unique positive number"})))))

(defn asset-builder
  [{:subs/keys [current-user current-asset customers dealerships state current-route]
    :keys [on-submit submit-component updating-asset?]}]
  [fork/form {:on-submit on-submit
              :prevent-default? true
              :keywordize-keys true
              :form-id :asset-builder
              :validation #(vlad/flat-errors asset-validation %)
              :path [::asset-builder]
              :state state
              :initial-values (if current-asset
                                (collapse-cell-config (:raw-data @current-asset))
                                (merge
                                 {:contract true
                                  :category "Truck Scale"}
                                 (:query-params @current-route)))}
   (fn [{:keys [state values handle-submit handle-change handle-blur touched
                errors attempted-submissions]}]
     [:<>
      [:form.add-asset {:on-submit handle-submit
                        :on-key-down (fn [event]
                                       (let [key (. event -key)]
                                         (when (= "Enter" key)
                                           (. event preventDefault))))}
       (let [{:keys [name customer category dealership location contract gateway]} values]
         [:div.asset-parameters
          [:div.form__group
           [:div
            [:label.form-label.form__label {:for :name} "Asset Name"]]
           [:div
            [:input.form-control.long-input
             {:name :name
              :type :text
              :placeholder "Enter a descriptive name for your asset"
              :value name
              :on-change handle-change
              :on-blur handle-blur}]]]

          (when (contains? (:permissions @current-user) :modify-dealerships)
            [:div.form__group
             [:div
              [:label.form-label.form__label {:for :dealership} "Dealership"]]
             [:div
              (into [:select.form-control.form__dropdown-select
                     {:class "form-select"
                      :name :dealership
                      :value (or dealership "")
                      :on-change handle-change
                      :on-blur handle-blur}
                     [:option "Select a dealership"]]
                    (for [dealership @dealerships]
                      [:option {:value (site/to-plain-id dealership)} (:name dealership)]))]])

          [:div.form__group
           [:div
            [:label.form-label.form__label {:for :customer} "Customer"]]
           [:div
            (into [:select.form-control.form__dropdown-select
                   {:class "form-select"
                    :name :customer
                    :value (or customer "")
                    :on-change handle-change
                    :on-blur handle-blur}
                   [:option "Select a customer"]]
                  (for [customer @customers]
                    [:option {:value (site/to-plain-id customer)} (:name customer)]))]

           [:div
            [:button.btn.btn--action
             {:type "button"
              :on-click #(rf/dispatch [:navigate :add-customer])}
             [:span.padding-right-sm "Add Customer"]
             [:i.fas.fa-plus.color-success]]]]

          (let [categories ["Truck Scale" "Floor Scale" "Bench Scale" "Tank Scale" "Other"]]
            [:div.form__group
             [:div
              [:label.form-label.form__label {:for :category} "Category"]]
             [:div
              (into [:select.form-control.form__dropdown-select
                     {:class "form-select"
                      :name :category
                      :value (or category "")
                      :on-change handle-change
                      :on-blur handle-blur}]
                    (for [category categories]
                      [:option {:value category} category]))]])

          [:div.form__group
           [:div
            [:label.form-label.form__label {:for :location} "Address"]]

           [:div
            [:input.form-control.long-input
             {:name :location
              :type :text
              :placeholder "Enter the asset address"
              :value location
              :on-change handle-change
              :on-blur handle-blur}]]]

          ;; Rice Lake want this out for now but will want later
          #_
          [:div.form__group
           [:div
            [:label.form-label.form__label {:for :contract} "Contract"]]
           [:div
            [:select.form-control.form__dropdown-select
             {:class "form-select"
              :name :contract
              :value (or contract "")
              :on-change handle-change
              :on-blur handle-blur}
             [:option {:value true} "Yes"]
             [:option {:value false} "No"]]]]

          [:div.form__group
           [:div
            [:label.form-label.form__label {:for :gateway} "Gateway ID"]]
           [:div
            [:input.form-control
             (merge {:name :gateway
                     :type :text
                     :value gateway}
                    (if current-asset
                      {:read-only true}
                      {:placeholder "000000000001-000000001234"
                       :on-change handle-change
                       :on-blur handle-blur}))]]
           [:div
            [components/button-with-dropdown
             (let [add-component!
                   (fn [{:keys [component-type]
                         :as component}]
                     (fn [event]
                       (swap! state update-in [:values :components]
                              (fn [components]
                                (vec
                                 (if-not (potpuri/find-first
                                          components
                                          {:component-type component-type})
                                   (conj (or components []) component)
                                   components))))))]
               {:options [{:label "Scale - iQube2"
                           :on-click (add-component!
                                      {:component-type "iqube2"
                                       :name "iQube2"
                                       :port "10001"
                                       :timeout 5000
                                       :scale 1})}
                          {:label "Cell Configuration"
                           :on-click (add-component!
                                      {:component-type "cell-config"
                                       :cells (resize-cells [] 4)})}
                          {:label "IP Camera"
                           :on-click (add-component!
                                      {:component-type "camera"
                                       :name "IP Camera"
                                       :port "8080"
                                       :timeout 5000})}
                          {:label "Indicator"
                           :on-click (add-component!
                                      {:component-type "indicator"
                                       :name "Indicator"})}
                          {:label "Remote Display"
                           :on-click (add-component!
                                      {:component-type "remote-display"
                                       :name "Remote Display"})}]
                :button
                [:button.btn.btn--action
                 {:type "button"}
                 [:span.padding-right-sm "Add Component"]
                 [:i.fas.fa-plus.color-success]]})]]]])

       [asset-builder-components {:state state}]

       (when (and (pos? attempted-submissions) errors)
         [:div.add-asset__validation-errors
          (for [error errors]
            ^{:key error}
            [:span error])])

       [:div.add-asset__submit-group
        submit-component]]
      (when @(rf/subscribe [:dev-options?])
        [:pre.mt-4.bg-gray-100.rounded-md.p-4
         (with-out-str (cljs.pprint/pprint values))])])])

(defn add-asset-view
  []
  (let [state (r/atom {})
        current-user (rf/subscribe [::sub/current-user])
        superuser? (contains? (set (:roles @current-user)) "superuser")
        builder-subscriptions #:subs{:current-user current-user
                                     :customers (rf/subscribe [::sub/data :customers])
                                     :dealerships (rf/subscribe [::sub/data :dealerships])
                                     :current-route (rf/subscribe [::sub/current-route])
                                     :state state}
        handle-submit (fn [{:keys [values] :as fork-data}]
                        (let [expanded-asset (expand-cell-config values)]
                          (rf/dispatch
                           [::events/add-asset
                            (cond-> expanded-asset
                              :always (assoc :type "Asset")
                              (empty? (:dealership expanded-asset))
                              (assoc :dealership (:dealership @current-user)))])))]
    [:div
     [:h1.text-lg.margin-bottom-lg "New Asset"]
     [asset-builder (merge builder-subscriptions
                           {:on-submit handle-submit
                            :submit-component [:input.btn.btn--action
                                               {:type "submit"
                                                :value "Add Asset"}]})]]))

(defn edit-asset-view
  []
  (let [state (r/atom {})
        current-user (rf/subscribe [::sub/current-user])
        current-asset (rf/subscribe [::sub/current-asset])
        superuser? (contains? (set (:roles @current-user)) "superuser")
        builder-subscriptions #:subs{:current-user current-user
                                     :current-asset current-asset
                                     :customers (rf/subscribe [::sub/data :customers])
                                     :dealerships (rf/subscribe [::sub/data :dealerships])
                                     :current-route (rf/subscribe [::sub/current-route])
                                     :state state}
        handle-submit (fn [{:keys [values] :as fork-data}]
                        (let [expanded-asset (expand-cell-config values)]
                          (rf/dispatch
                           [::events/update-asset
                            (cond-> expanded-asset
                              :always (assoc :type "Asset")
                              (empty? (:dealership expanded-asset))
                              (assoc :dealership (:dealership @current-user)))])))
        submit-component [:<>
                          [:input.btn.btn-success
                           {:type "submit"
                            :value "Update Asset"}]
                          [:input.btn.btn-danger
                           {:type "button"
                            :value "Delete Asset"
                            :on-click
                            (fn []
                              (components/confirmation-dialog
                               {:action-fn
                                #(rf/dispatch
                                  [::events/delete-asset @current-asset])
                                :text "Are you sure you want to delete this asset?"
                                :title "Confirm Delete"}))}]
                          [:input.btn.btn--action
                           {:type "button"
                            :value "Cancel"
                            :on-click
                            (fn []
                              (rf/dispatch
                               [:navigate
                                :asset
                                {:asset (site/to-plain-id @current-asset)}]))}]]]
    [:div
     [:h1.text-lg.margin-bottom-lg "Edit Asset"]
     (if @current-asset
       ^{:key (get-in @current-asset [:raw-data :gateway])}
       [asset-builder (merge builder-subscriptions
                             {:on-submit handle-submit
                              :submit-component submit-component})]
       [components/loader])]))


(defn site-builder
  [{:subs/keys [openapi current-user dealerships form-state]}])

(defn add-customer-view
  []
  (let [state (r/atom nil)]
    [:div {:style {:max-width "640px"}}
     [:h1.text-lg.margin-bottom-lg "New Customer"]]))
